var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "confirm-container", class: _vm.classStr }, [
    _c("div", { staticClass: "confirm-wrapper" }, [
      _c(
        "div",
        { staticClass: "title", class: { __ellipsis: !_vm.closeIcon } },
        [
          _vm._v("\n            " + _vm._s(_vm.title) + "\n            "),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.closeIcon,
                expression: "closeIcon"
              }
            ],
            staticClass: "close-icon __pointer",
            on: { click: _vm.close }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-wrapper" },
        [
          _vm.type === "generalTips"
            ? _c("img", {
                staticClass: "general-tips-icon",
                attrs: { src: require("assets/imgs/general-tips.svg") }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.content ? _c("div", [_vm._v(_vm._s(_vm.content))]) : _vm._e(),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.singleBtn || _vm.leftBtnTxt || _vm.rightBtnTxt,
              expression: "singleBtn || leftBtnTxt || rightBtnTxt"
            }
          ],
          staticClass: "bottom",
          class: { single: _vm.singleBtn }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.singleBtn,
                  expression: "singleBtn"
                }
              ],
              staticClass: "btn btn-single btn-blue __pointer",
              class: { "btn-gray": _vm.btnUnuse && !_vm.isLoading },
              on: { click: _vm._leftBtnClick }
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isLoading,
                      expression: "!isLoading"
                    }
                  ]
                },
                [_vm._v(_vm._s(_vm.leftBtnTxt))]
              ),
              _vm._v(" "),
              _c("loading", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoading,
                    expression: "isLoading"
                  }
                ],
                attrs: { loadingType: "dot" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.singleBtn,
                  expression: "!singleBtn"
                }
              ],
              staticClass: "btn btn-border __pointer",
              on: { click: _vm._leftBtnClick }
            },
            [_vm._v(_vm._s(_vm.leftBtnTxt))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.singleBtn,
                  expression: "!singleBtn"
                }
              ],
              staticClass: "btn btn-blue __pointer",
              class: { "btn-gray": _vm.btnUnuse && !_vm.isLoading },
              on: { click: _vm._rightBtnClick }
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isLoading,
                      expression: "!isLoading"
                    }
                  ]
                },
                [_vm._v(_vm._s(_vm.rightBtnTxt))]
              ),
              _vm._v(" "),
              _c("loading", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoading,
                    expression: "isLoading"
                  }
                ],
                attrs: { loadingType: "dot" }
              })
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }